import { z } from 'zod';

const TematicaSchema = z.object({
  id: z.number(),
  nombre: z.string()
}).nullable().optional();

export const ObtenerUsuarioResponseSchema = z.object({
  nombre: z.string(),
  apellido: z.string(),
  email: z.string(),
  configuracion_json: z.any().nullable().optional(),
  datos_externos_json: z.any().nullable().optional(),
  timezone: z.string().optional(),
  tematica: TematicaSchema,
  id: z.number()
}).passthrough();

export type ObtenerUsuarioResponse = z.infer<typeof ObtenerUsuarioResponseSchema>; 